import React from 'react';
import { Badge } from '../ui/badge';
import { MailCheck, MailOpen, MousePointerClick, MailX, Send } from 'lucide-react';

/**
 * Affiche « d'un coup d'œil » l'état de délivrabilité d'une invitation
 * (délivré / ouvert / cliqué / rejeté), alimenté par le webhook Brevo ou
 * la vérification live Brevo.
 */
export default function DeliveryStatusBadges({ delivery }) {
  if (!delivery) return null;
  const { delivered, opened, clicked, bounced, stage } = delivery;

  if (bounced) {
    return (
      <Badge className="bg-rose-600 text-white font-semibold gap-1" data-testid="delivery-badge-bounced">
        <MailX className="h-3 w-3" /> Rejeté
      </Badge>
    );
  }

  const chips = [];
  if (delivered) {
    chips.push(
      <Badge key="d" className="bg-emerald-600 text-white font-semibold gap-1" data-testid="delivery-badge-delivered">
        <MailCheck className="h-3 w-3" /> Délivré
      </Badge>
    );
  }
  if (opened) {
    chips.push(
      <Badge key="o" className="bg-blue-600 text-white font-semibold gap-1" data-testid="delivery-badge-opened">
        <MailOpen className="h-3 w-3" /> Ouvert
      </Badge>
    );
  }
  if (clicked) {
    chips.push(
      <Badge key="c" className="bg-violet-600 text-white font-semibold gap-1" data-testid="delivery-badge-clicked">
        <MousePointerClick className="h-3 w-3" /> Cliqué
      </Badge>
    );
  }

  if (chips.length > 0) return <div className="flex flex-wrap gap-1">{chips}</div>;

  // Envoyé mais pas encore de confirmation de réception
  if (stage === 'sent') {
    return (
      <Badge variant="outline" className="gap-1 text-slate-500" data-testid="delivery-badge-sent">
        <Send className="h-3 w-3" /> Envoyé
      </Badge>
    );
  }
  return null;
}
